<template>
  <m-modal v-if="options" :title="options.title" @close="handleClose(false)">
    <m-form>
      <p>{{ options.message }}</p>
      <template #actions>
        <m-button v-if="showCancel" theme="link" @click="handleClose(false)">{{ cancelText }}</m-button>
        <m-button @click="handleClose(true)">{{ confirmText }}</m-button>
      </template>
    </m-form>
  </m-modal>
</template>
<script setup lang="ts">
  import { computed, ref } from 'vue';
  import MModal from '@shared/components/MModal/MModal.vue';
  import MForm from '@core/components/MForm/MForm.vue';
  import MButton from '@core/components/MButton/MButton.vue';
  import { EVENTS, globalEventBus } from './eventBus';
  import type { PrivatePromptOptions } from './interfaces';

  const options = ref<PrivatePromptOptions | null>(null);

  const showCancel = computed(() => options.value?.type === 'confirm');
  const cancelText = computed(() => options.value?.cancelText || 'Cancel');
  const confirmText = computed(() => options.value?.confirmText || 'Confirm');

  const handleClose = (val: boolean) => {
    globalEventBus.emit(EVENTS.FINISH_CONFIRM, { result: val });
    options.value = null;
  };
  globalEventBus.on(EVENTS.PROMPT, (opts) => {
    options.value = opts;
  });
</script>
<style scoped>
  .btn.btn-primary,
  .btn.btn-accent {
    @apply rounded normal-case;
  }

  button.link {
    @apply font-bold underline underline-offset-4;
  }
</style>
